import React, { PureComponent } from 'react'
import { LoanProvider } from '../shared/LoanContext'
import { SectionTitle } from '../shared/stylesheets/Titles'
import { TableWrapper, Row } from './components/index'

class SectionTable extends PureComponent {
  adminCanEditRow = () => {
    const { canEdit, customerService } = this.props

    let canEditRow = false
    if (canEdit) {
      canEditRow = customerService
    }

    return canEditRow
  }
  render() {
    const { 
      props: { objectRows, sectionTitle, loan, customHeaders, section, helpers },
      adminCanEditRow
    } = this

    return (
      <LoanProvider value={loan}>
        <SectionTitle>{sectionTitle}</SectionTitle>
        <TableWrapper customHeaders={customHeaders}>
          {objectRows.map((row, i) => (
            <Row key={`row-${section}-${i}`}
              row={row}
              helpers={helpers}
              canEditRow={adminCanEditRow()}
              columnSize={customHeaders?.length || 2}
              loan={loan}
            />
          ))}
        </TableWrapper>
      </LoanProvider>
    )
  }
}

export default SectionTable